// @flow
import React from 'react';

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import FontIcon from 'material-ui/FontIcon';

import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

import { cyan500 } from 'material-ui/styles/colors';

const icon = which => (
  <FontIcon className="material-icons" color={cyan500}>
    {which}
  </FontIcon>
);

const TUTORIAL_URL =
  'https://legter.hu/hogyan-hasznaljuk-a-legterkeresot-a-terkep-legter-hu-oldalon/';
const LEGAL_URL = 'https://legter.hu/jogi-nyilatkozat/';
const CONTACT_URL = 'https://legter.hu/rolunk/legter-hu-kft/';

export default ({ open }) => (
  <IconMenu
    className="intro-tour__step-5"
    key="support-menu"
    iconButtonElement={
      <IconButton
        iconClassName="material-icons"
        tooltip="Súgó és kapcsolatfelvétel"
        tooltipPosition="bottom-left"
        iconStyle={{ color: cyan500 }}
      >
        help
      </IconButton>
    }
    targetOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
  >
    <Subheader>Támogatás</Subheader>
    <MenuItem
      primaryText="Az alkalmazás használata..."
      leftIcon={icon('help')}
      onClick={() => window.open(TUTORIAL_URL, '_blank')}
    />
    <MenuItem
      primaryText="Jogi nyilatkozat..."
      leftIcon={icon('verified_user')}
      onClick={() => window.open(LEGAL_URL, '_blank')}
    />

    <Divider />
    <Subheader>Vegye fel velünk a kapcsolatot!</Subheader>

    <MenuItem
      primaryText="legter@legter.hu"
      leftIcon={icon('email')}
      onClick={() => window.open('mailto:legter@legter.hu', '_blank')}
    />
    <Divider inset />
    <MenuItem
      insetChildren
      primaryText="További kapcsolatfelvételi lehetőségek..."
      style={{ fontSize: 'smaller' }}
      onClick={() => window.open(CONTACT_URL, '_blank')}
    />
  </IconMenu>
);



// WEBPACK FOOTER //
// ./components/AppBar/SupportPopover.js